export interface Props {
    tag: string
    canRemove: boolean;
    onRemove?: (tag: string) => void;
}

const EmailTag = (props: Props) => {
    return (
        <span className="inline-flex items-center gap-1 px-1.5 py-px rounded text-[10.5px] font-medium bg-accent-soft text-accent">
            {props.tag}
            {props.canRemove && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        props.onRemove?.(props.tag);
                    }}
                    className="bg-transparent border-0 p-0 cursor-pointer text-accent/50 hover:text-accent leading-none text-[10px]"
                >
                    ✕
                </button>
            )}
        </span>
    );
};
export default EmailTag;
